module.exports = __webpack_public_path__ + "img/agreement-arrow.svg?4cc375cebf830b9f4aaffed3a6565b8c";